<template>
  <section class="content-post-register">
    <Breadcrumb
      :links="links"
      :data="{ name: 'Post', id: postParams.id_post, module: 'Blog' }"
    />
    <form class="content-post-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6 content-select-category">
          <div
            class="content-input-default-select"
            :class="{
              'content-input-default-select--active':
                selectedCategory && selectedCategory !== '',
            }"
          >
            <select v-model="selectedCategory" required>
              <option value="" selected disabled>Selecione a categoria</option>
              <option
                :value="category.id"
                v-for="category in categories"
                :key="category.id"
              >
                {{ category.name }}
              </option>
            </select>
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_35_1490"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="7"
                height="12"
                style="mask-type: luminance"
              >
                <path
                  d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z"
                  fill="white"
                ></path>
              </mask>
              <g mask="url(#mask0_35_1490)">
                <path
                  d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z"
                  fill="black"
                ></path>
              </g>
            </svg>
          </div>
          <label class="not-find--category"
            >Não encontrou a categoria?
            <a @click="openModal()">Cadastrar</a></label
          >
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input
              type="text"
              name="title_description"
              v-model="post.title_description"
              value=""
              placeholder="Título de descrição"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea
              name="text_description"
              v-model="post.text_description"
              placeholder="Texto de descrição"
              style="min-height: 100px"
              required
            ></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <quill-editor
              v-model="post.contentHtml"
              ref="refQuillEditor"
              :options="quillOptions"
            ></quill-editor>
          </div>
        </div>
        <div class="col-12">
          <UploadImageV2 @changePicture="handleUploadFile" />
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapActions, mapGetters } from "vuex";
import UploadImageV2 from "@/components/uploadV2/Index";

export default {
  data() {
    return {
      links: [
        {
          name: "Blog",
          routerName: "Blog",
        },
        {
          name: "Novo Post",
          routerName: "RegisterPosts",
        },
      ],
      post: {
        id_user: "",
        id_blog_category: "",
        title_description: "",
        text_description: "",
        contentHtml: "",
        picture: null,
        picture_file_name: null,
        picture_file_path: null,
      },
      selectedCategory: "",
      quillOptions: {
        placeholder: "Descreva as informações completa sobre a publicação",
        readonly: false,
      },
      postParams: this.$route.params,
    };
  },
  components: {
    Breadcrumb,
    UploadImageV2,
  },
  computed: {
    ...mapGetters({
      categories: "Blog/blogCategories",
      categoriesWithPosts: "Blog/categoriesWithPosts",
      isHighlight: "Blog/isHighlight",
      isPremium: "Blog/isPremium",
      user: "User/user",
    }),
  },
  watch: {
    categoriesWithPosts: {
      handler(newValue) {
        this.post = newValue[0].posts[0];
        this.links[1].name = this.post.title_description;
      },
    },
  },
  methods: {
    ...mapActions("Blog", [
      "consultCategoriesBlogNoImage",
      "consultCategoriesWithPosts",
      "registerPost",
      "setDataDefault",
    ]),
    ...mapActions(["setImageFileUrl", "setModalCategory"]),
    async handleSubmit() {
      let message = this.post?.id_post
        ? "Post editado com sucesso!"
        : "Post cadastrado com sucesso!";
      this.post.id_blog_category = this.selectedCategory;
      this.post.is_highlight = this.isHighlight;
      this.post.is_premium = this.isPremium;

      if (this.post.picture_file_name && this.post.picture_file_path) {
        this.post.picture = null;
      }

      await this.registerPost(this.post);
      this.$router.push({
        name: "ListPostsByCategory",
        params: { idCategory: this.post.id_category },
      });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
    openModal() {
      this.setModalCategory({ isType: "Blog" });
      this.$bvModal.show("modal-category");
    },
    clearInputsFile() {
      this.picture = null;
      this.post.picture_file_name = null;
      this.post.picture_file_path = null;
    },
    handleUploadFile(objFile) {
      if (!objFile) {
        this.clearInputsFile();
        return;
      }

      this.post.picture_file_name = objFile.name;
      this.post.picture = objFile.url;
    },
  },
  async mounted() {
    this.post.id_user = await this.user.id;
    this.consultCategoriesBlogNoImage();
    this.setImageFileUrl(null);
    if (this.postParams && Object.keys(this.postParams).length > 0) {
      await this.consultCategoriesWithPosts(this.postParams);
      this.post = this.categoriesWithPosts[0].posts[0];
      this.setDataDefault(["SET_IS_HIGHLIGHT", this.post.is_highlight]);
      this.setDataDefault(["SET_IS_PREMIUM", this.post.is_premium]);
      this.selectedCategory = this.post.id_category;
      this.links[1].name = this.post.title_description;
      const objImage = this.post.post_picture
        ? { url: this.post.post_picture, isFileBase64: true }
        : {
            name: this.post.picture_file_name,
            url: this.post.picture_file_path,
          };
      this.setImageFileUrl(objImage);
    }
  },
};
</script>

<style lang="scss" scoped>
.content-post-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
.content-select-category {
  margin-bottom: 30px;
  .content-input-default-select {
    margin-bottom: 0;
  }
  .not-find--category {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: "Font Light";
    color: var(--gray-dark);
    padding: 5px 20px;
    margin-bottom: 0;
    a {
      display: block;
      font-family: "Font Regular";
      color: var(--blue);
      text-decoration: underline !important;
      text-decoration-color: var(--blue) !important;
      margin-left: 5px;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.6;
      }
    }
  }
}
</style>
